const DEFAULT_MESSAGES = {
  // ----- AUTH / ONBOARDING -----
  "auth.adminLoginSuccess": "Admin login successful.",
  "auth.fetchOrgProfileFailed": "Failed to fetch organization profile.",
  "auth.fetchOrgProfileError": "Error fetching organization profile.",
  "auth.orgIdRequired": "Organization ID is required",
  "auth.orgIdRequiredError": "Organization ID is required.",
  "auth.azureLoginFailed": "Azure login failed.",
  "auth.consumerNotFound": "Consumer not found.",
  "auth.graphApiError": "Graph API error",
  "auth.backendError": "Backend error",
  "auth.fetchUserError": "Error fetching user details.",
  "auth.loginFailed": "Login failed.",
  "auth.invalidRoles": "Invalid roles from server.",
  "auth.noValidRole": "No valid role assigned.",
  "auth.fetchApproverError": "Error fetching approver data.",
  "auth.accountCreated": "Account created successfully!",
  "auth.accountCreatedWithOrgId":
    "Account created successfully! Use Organization ID {orgId} to update or reset password clicking above lock sign icon",
  "auth.genericError": "An error occurred. Please try again.",
  "auth.msNoEmail": "Microsoft account does not contain an email.",
  "auth.processingLogin": "Processing Microsoft Login...",
  "auth.authenticationFailed": "Authentication failed. Please try again.",

  // ----- PASSWORD RESET -----
  "auth.otpSent": "OTP sent to your email!",
  "auth.otpSendFailed": "Failed to send OTP",
  "auth.passwordsMismatch": "Passwords do not match!",
  "auth.passwordReset": "Password reset successfully!",
  "auth.passwordResetFailed": "Failed to reset password",

  // ----- PAYMENT / UPGRADE -----
  "payment.sdkLoadFailed": "Payment SDK failed to load.",
  "payment.razorpaySdkFailed": "Razorpay SDK failed to load",
  "payment.paymentSuccess": "Payment successful! Your account is now upgraded.",
  "payment.upgradeFailed": "Upgrade failed. Please try again.",
  "payment.allFieldsRequired": "All fields are required",
  "payment.validPhone": "Enter a valid phone number",
  "payment.subscriptionFailed": "Subscription failed",
  "payment.paymentNotConfigured": "Payment system not configured. Please contact support.",

  // ----- BOOKING / CONSULTANT -----
  "booking.loadConsultantsFailed": "Failed to load consultants. Please try again.",
  "booking.loadSlotsFailed": "Failed to load available slots. Please try again.",
  "booking.selectConsultant": "Please select a consultant first.",
  "booking.nameEmailRequired": "Please provide your name and email before booking.",
  "booking.invalidEmail": "Please enter a valid email address.",
  "booking.selectDate": "Please select a preferred date for your session.",
  "booking.futureDate": "Preferred date must be today or a future date.",
  "booking.selectTimeSlot": "Please select a preferred time slot.",
  "booking.slotUnavailable":
    "Selected time slot is no longer available. Please choose another.",
  "booking.paymentNotConfigured": "Payment is not configured. Please contact support.",
  "booking.paymentSdkFailed": "Payment SDK failed to load. Please try again.",
  "booking.paymentReceived":
    "Payment received! Booking request sent to {name}. Our team will confirm your slot!",
  "booking.slotTaken": "Slot already taken. Your payment will be refunded.",
  "booking.paymentFailedContact":
    "Payment received but booking failed. Our team will contact you.",
  "booking.bookingFailed": "Booking failed. Please try again.",

  // ----- ENTERPRISE / UPGRADE PAGE -----
  "enterprise.inquirySent": "Your message has been sent. Our team will reach out shortly.",
  "enterprise.inquiryFailed": "Failed to send your message. Please try again.",
  "enterprise.planUserLimit":
    "{label} supports up to {maxUsers} users. Please reduce the user count or choose Enterprise.",

  // ----- USER MANAGEMENT -----
  "users.userLimitReached":
    "User limit reached ({count} of {max}). Please upgrade your plan to add more users.",
  "users.deleted": "User deleted successfully!",
  "users.deleteFailed": "Failed to delete user.",
  "users.invited": "User invited successfully!",
  "users.inviteFailed": "Failed to invite user.",
  "users.updated": "User updated successfully!",
  "users.updateFailed": "Failed to update user.",

  // ----- APPROVER WORKFLOW -----
  "approver.decisionAndCommentRequired": "Please provide a decision and a comment.",
  "approver.decisionSaved": "Decision saved successfully.",
  "approver.decisionSaveFailed": "Failed to save the decision.",
  "approver.selectDecision": "Please select a decision before saving.",
  "approver.planDecisionSaved": "Plan {status} successfully!",
  "approver.planDecisionSaveFailed": "Failed to save plan action. Please try again.",

  // ----- CONTENT GENERATORS -----
  "content.fileLocked": "File {fileName} is locked.",
  "content.generateImageFirst": "Please generate an image first.",
  "content.generateOrSelectImageFirst": "Please generate/select an image first.",
  "content.docGenerated":
    "Document generated successfully! Click on 'Save' to save the document and click send for approval.",
  "content.docAdsGenerated":
    "Document Ads generated successfully! Click on 'Save' to save the document and click send for approval.",
  "content.genFailed": "Error generating document.",
  "content.genFailedTryAgain": "Failed to generate document. Please try again.",
  "content.genValidationError":
    "Failed to generate. Please check your inputs and try again.",
  "content.genApiError": "Failed to generate. Please try again.",
  "content.promptAndFileNameRequired":
    "Please enter both an input prompt and a file name.",
  "content.selectCampaign": "Please select a campaign.",
  "content.itemCreated": "{type} {fileName} is created.",
  "content.imageGeneratedSuccess": "Image generated successfully!",
  "content.canvaLoadFailed": "Unable to load Canva designs. Please login first.",

  // ----- CANVA IMPORT -----
  "canva.notLoggedIn": "Please login to Canva to load designs.",
  "canva.exportFailed": "Export failed. Please try again.",

  // ----- WORKFLOW STATUS -----
  "workflow.loginFirst": "Login first before starting.",
  "workflow.upgradeFirst": "Please upgrade first.",
  "workflow.enablePopups":
    "Please enable 'Pop-ups and redirects' in browser's setting.",
  "workflow.templateDownloadFailed": "Failed to download template. Please try again.",

  // ----- CAMPAIGN / ACTIVITY -----
  "campaign.selectAssetToLaunch":
    "Please select at least one asset to launch the campaign.",
  "campaign.fillRequiredFields":
    "Please fill in all required fields (Name, Title, Description).",
  "campaign.selectObjective": "Please select a campaign objective.",
  "campaign.launched": "Campaign launched successfully!",
  "campaign.launchFailed": "Failed to launch campaign: {detail}",
  "campaign.activityRequiredBuOffering":
    "Error: Business Unit {businessUnit} and Offerings {offerings} must be selected.",
  "campaign.activityRequiredFileDetails":
    "Error: File name {fileName}, File Type {fileType} and File path {filePath} must be set.",
  "campaign.activityCreated": "Activity created: {fileName}.",
  "campaign.apiCallError": "Failed to submit. Please try again.",
  "campaign.selectCampaign": "Please select a campaign.",
  "campaign.selectCampaignShort": "Please select campaign.",
  "campaign.createAssetFirst": "Please create asset first.",
  "campaign.created": "Campaign created successfully!",
  "campaign.createGroupFailed":
    "Failed to create campaign group in ads account {account} . Please try again.",
  "campaign.noApprovedBudget": "There is no approved budget for {platform}",
  "campaign.noApprovedAsset":
    "There is no approved asset in this campaign for {platform}",
  "campaign.selectPlatform": "Please select platform.",
  "campaign.selectResource": "Please select a resource.",
  "campaign.resourceAdded": "Resource added",
  "campaign.resourceDeleted": "Resource id {id} deleted successfully",
  "campaign.resourceNotDeleted": "Resource id {id} not deleted.",
  "campaign.resourceDeleteFailed": "Failed to delete resource.",
  "campaign.errorOccurred": "Error occurred",
  "campaign.creativeStatsError": "Error: {status} Message: {message}",
  "campaign.creativeStatsFetchFailed":
    "Failed to fetch stats. Please try again.",

  // ----- BRAINSTORM -----
  "brainstorm.emailRequired": "Please input email addresses",
  "brainstorm.subjectRequired": "Please input subject",
  "brainstorm.contentRequired": "Please input email content",
  "socialmedia.newPrompt": "newPrompt : {newPrompt}",

  // ----- SAVED PROMPTS -----
  "useSavedPrompts.imageRequired": "Please generate an image before saving a prompt.",
  "useSavedPrompts.fileNameRequired": "Please provide a valid file name.",
  "useSavedPrompts.loginRequired": "Please log in before saving a prompt.",
  "useSavedPrompts.saving": "Saving prompt...",
  "useSavedPrompts.promptSaved": "Prompt saved successfully.",
  "useSavedPrompts.promptSaveFailed": "Failed to save prompt. Please try again.",
  "useSavedPrompts.bannerDeleted": "Saved banner deleted.",
  "useSavedPrompts.bannerDeleteFailed": "Failed to delete saved banner.",
  "dialog.fileRequired": "Please select a file to upload.",
  "dialog.assetAdded": "Added Asset successfully",
  "dialog.assetAddFailed": "Failed to add asset.",
  "dialog.assetDeleted": "Asset Deleted successfully",
  "dialog.deleteBUFailed": "Failed to Delete BU",
  "dialog.fileAdded": "File added in DialogMarketingAssetsDefault's handleSaveMarketingAssets ",
};

const resolveMessage = (messages, key, values) => {
  const template = messages[key] ?? key;
  if (!values) return template;
  return template.replace(/\{(\w+)\}/g, (match, name) =>
    values[name] !== undefined && values[name] !== null
      ? String(values[name])
      : match
  );
};

const defaultMsg = (key, values) => resolveMessage(DEFAULT_MESSAGES, key, values);

export { DEFAULT_MESSAGES, resolveMessage, defaultMsg };